/**
* 請求管理詳細
*/
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'
import * as types from '../../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/sales/requests`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      sort_type1: null,
      sort_type2: null,
      sort_type3: null,
      sort_type4: null,
      sort_type5: null,
    },
  }
}

const sales_request_billing_detail = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 請求詳細
     * @param dispatch
     * @param commit
     * @param state
     * @param sort_type1
     * @param sort_type2
     * @param sort_type3
     * @param sort_type4
     * @param sort_type5
     * @param status
     * @param page
     * @param format
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { id, sort_type1, sort_type2, sort_type3, sort_type4, sort_type5, page, format }) {
      dispatch('saveCondition', {
        sort_type1: sort_type1,
        sort_type2: sort_type2,
        sort_type3: sort_type3,
        sort_type4: sort_type4,
        sort_type5: sort_type5
      })
      const params = {
        sort_type1: state.condition.sort_type1,
        sort_type2: state.condition.sort_type2,
        sort_type3: state.condition.sort_type3,
        sort_type4: state.condition.sort_type4,
        sort_type5: state.condition.sort_type5,
        page: page,
      }
      return new Promise((resolve) => {
        const api_path = `${API_PATH}/${id}/billing_details`
        Vue.$http.get(api_path, { params: params }).then(data => {
          let content = data.content
          commit(types.DRIVER_SALES_REQUEST_DETAIL_PAGINATION, { content })
          resolve(content)
        })
      })
    },
    saveCondition ({ commit, state }, { sort_type1, sort_type2, sort_type3, sort_type4, sort_type5 }) {
      const _sort_type1 = (sort_type1 !== undefined) ? sort_type1 : state.condition.sort_type1
      const _sort_type2 = (sort_type2 !== undefined) ? sort_type2 : state.condition.sort_type2
      const _sort_type3 = (sort_type3 !== undefined) ? sort_type3 : state.condition.sort_type3
      const _sort_type4 = (sort_type4 !== undefined) ? sort_type4 : state.condition.sort_type4
      const _sort_type5 = (sort_type5 !== undefined) ? sort_type5 : state.condition.sort_type5
      const params = {
        sort_type1: _sort_type1,
        sort_type2: _sort_type2,
        sort_type3: _sort_type3,
        sort_type4: _sort_type4,
        sort_type5: _sort_type5,
      }
      commit(types.DRIVER_SALES_REQUEST_DETAIL_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_SALES_REQUEST_DETAIL_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_SALES_REQUEST_DETAIL_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_SALES_REQUEST_DETAIL_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_SALES_REQUEST_DETAIL_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.DRIVER_SALES_REQUEST_DETAIL_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_SALES_REQUEST_DETAIL_CONDITION] (state, { params }) {
      state.condition.sort_type1 = params.sort_type1
      state.condition.sort_type2 = params.sort_type2
      state.condition.sort_type3 = params.sort_type3
      state.condition.sort_type4 = params.sort_type4
      state.condition.sort_type5 = params.sort_type5
    }
  },

}
export default sales_request_billing_detail  
